export default __webpack_public_path__ + "static/media/anthony.02c6eb18.png";